import { ReactElement } from 'react'
import { salesReportIcons } from '../icons'
import { Box, Input, Label, Text } from './styles'

interface CheckboxProps {
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  dense?: boolean
}

export function Checkbox({ label, checked, onChange, disabled = false, dense = false }: CheckboxProps): ReactElement {
  return (
    <Label $disabled={disabled}>
      <Input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
      <Box $checked={checked} aria-hidden="true">
        {checked && <img src={salesReportIcons.check} alt="" width={11} height={11} />}
      </Box>
      <Text $dense={dense}>{label}</Text>
    </Label>
  )
}
